<template>
	<div>
		<!-- Mandators -->
		<v-row>
			<v-col cols="12">
				<mandator-filter
					:appNameShort="appNameShort"
					:disable="false"
					@changeSelectedValue="(...args)=>this.emitSelectedValue('mandator',...args)"
					@mandatorError="(...args) => this.emitErrorEvent('mandator',...args)"
				/>
			</v-col>
		</v-row>
		<!-- Data pickers from - till interval -->
		<v-row v-show="showFilters">
			<v-col cols="12" md="6">
				<date-picker
					:label="txt.labels.dateFrom"
					:setDateTodayMinusOneDay="true"
					:disabled="disabled"
					@emitDate="(...args) => this.emitSelectedValue('fromDate',...args)"
				/>
			</v-col>
			<v-col cols="12" md="6">
				<date-picker
					:label="txt.labels.dateTill"
					:disabled="disabled"
					@emitDate="(...args) => this.emitSelectedValue('tillDate',...args)"
				/>
			</v-col>
		</v-row>
		<v-row v-show="showFilters">
			<v-col cols="12" md="6">
				<!-- Service providers -->
				<generic-autocomplete
					:api="api.serviceprovider.basePart"
					:queryProps="api.serviceprovider.props"
					:queryPropValues="[this.selectedMandatorId]"
					:label="txt.labels.serviceprovider"
					:triggerValue="selectedMandatorId"
					:preSelectAndHideIfOneItem="false"
					:selectAllOption="false"
					:groupingEffect="false"
					:disabled="disabled"
					:show="showFilters"
					hintText=""
					@modelEmit="(...args) => this.emitSelectedValue('serviceproviders',...args)"
					@loading="(...args) => this.emitLoadingVariables('serviceproviders',...args)"
					@errorEmit="(...args) => this.emitErrorEvent('serviceproviders',...args)"
				/>
			</v-col>
			<v-col cols="12" md="6">
				<!-- product filter -->
				<generic-autocomplete
					:api="api.product.basePart"
					:queryProps="api.product.props"
					:queryPropValues="[this.selectedMandatorId]"
					:label="txt.labels.product"
					:triggerValue="this.selectedMandatorId"
					:preSelectAndHideIfOneItem="false"
					:selectAllOption="false"
					:groupingEffect="false"
					:disabled="disabled"
					:show="showFilters"
					@modelEmit="(...args) => this.emitSelectedValue('products',...args)"
					@loading="(...args) => this.emitLoadingVariables('products',...args)"
					@errorEmit="(...args) => this.emitErrorEvent('products',...args)"
				/>
			</v-col>
		</v-row>
		<v-row>
			<!--  sales channel filter -->
			<v-col cols="12" md="6">
				<generic-autocomplete
					:api="api.salesChannels.basePart"
					:queryProps="api.salesChannels.props"
					:queryPropValues="[this.selectedMandatorId]"
					:label="txt.labels.salesChannels"
					:triggerValue="this.selectedMandatorId"
					:preSelectAndHideIfOneItem="false"
					:selectAllOption="false"
					:groupingEffect="false"
					:disabled="disabled"
					:show="showFilters"
					@modelEmit="(...args) => this.emitSelectedValue('salesChannels',...args)"
					@loading="(...args) => this.emitLoadingVariables('salesChannels',...args)"
					@errorEmit="(...args) => this.emitErrorEvent('salesChannels',...args)"
				/>
			</v-col>
			<v-col cols="12" :md="colWidth">
				<v-combobox
					v-model="selectedBookings"
					:items="formItems.booking"
					label="Booking / refund"
					multiple
					chips
					:disabled="disabled"
					@change="(...args) => this.emitSelectedValue('booking',...args)"
				></v-combobox>
			</v-col>
		</v-row>
		<v-row>
			<v-col cols="12" :md="colWidth">
				<v-text-field
					v-model="selectedOrderIds"
					v-show="!paymentTransactionIdsFilled && !couponCodesFilled"
					label="Order IDs"
					:hint="txt.hints.orderIds"
					:disabled="disabled"
					@change="(...args) => this.emitSelectedValue('orderIds',...args)"
				></v-text-field>
			</v-col>
			<v-col cols="12" :md="colWidth">
				<v-text-field
					v-model="selectedPaymentTransactionIds"
					v-show="!orderIdsFilled && !couponCodesFilled"
					label="Payment transaction IDs"
					:hint="txt.hints.paymentTransactionIds"
					:disabled="disabled"
					@change="(...args) => this.emitSelectedValue('paymentTransactionIds',...args)"
				></v-text-field>
			</v-col>
		</v-row>
		<v-row>
			<v-col cols="12" md="12">
				<v-text-field
					v-model="selectedCouponCodes"
					v-show="!orderIdsFilled && !paymentTransactionIdsFilled"
					label="Coupon codes"
					:hint="txt.hints.couponCode"
					:disabled="disabled"
					@change="(...args) => this.emitSelectedValue('couponCodes',...args)"
				></v-text-field>
			</v-col>
		</v-row>
	</div>
</template>

<script>
import MandatorFilter from '../../arcCustom/filters/mandatorFilter.vue'
import GenericAutocomplete from '../../arcCustom/filters/GenericAutocomplete.vue'
import DatePicker from '../../arcCustom/DatePickerVue3.vue'

export default {
	name: 'BillingEngineFiltersPrimary',
	components: {
		MandatorFilter,
		DatePicker,
		GenericAutocomplete,
	},
	props: {
		appNameShort: {
			type: String,
			required: true,
		},
		selectedMandatorId: {
			type: Number,
			required: true,
		},
		disabled: {
			type: Boolean,
			required: true,
		},
	},
	watch: {
		showFilters: {
			handler(value) {
				this.$emit('showFilterChanged', value)
			},
		},
	},
	data() {
		return {
			selectedNationalitiesIso: [],
			selectedFromDates: [],
			selectedTillDates: [],
			selectedBookings: [],
			selectedOrderIds: '',
			selectedPaymentTransactionIds: '',
			selectedCouponCodes: '',
			api: {
				serviceprovider: {
					basePart: '/billing-engine/service-providers',
					props: [{ name: 'installationid', value: 9999 }],
				},
				product: {
					basePart: '/billing-engine/products',
					props: [{ name: 'installationid', value: 9999 }],
				},
				salesChannels: {
					basePart: '/billing-engine/sales-channels',
					props: [{ name: 'installationid', value: 9999 }],
				},
			},
			txt: {
				labels: {
					dateFrom: 'Payment date from',
					dateTill: 'Payment date till',
					serviceprovider: 'Service providers',
					product: 'Products',
					salesChannels: 'Sales channels',
				},
				hints: {
					orderIds: 'Enter order ids separated by comma, semi-colon or space (digits only)',
					paymentTransactionIds: 'Enter payment transaction ids separated by comma, semi-colon or space (alphanumeric only, dash allowed)',
					couponCode: 'Enter coupon codes separated by comma, semi-colon or space (alphanumeric only, dash allowed)',
				},
			},
			formItems: {
				booking: [
					{ text: 'Bookings', value: 0 },
					{ text: 'Refunds', value: 1 },
				],
			},
		}
	},
	methods: {
		emitSelectedValue(filterId, values) {
			const emittedObject = {
				filterId,
				values,
			}
			if (emittedObject.filterId == 'isoNationality') this.handleIsoShowing(values)
			this.$emit('emitSelectedValue', emittedObject)
		},
		emitLoadingVariables(filterId, value) {
			const emittedObject = {
				filterId,
				value,
			}
			this.$emit('emitLoadingVariables', emittedObject)
		},
		emitErrorEvent(filterId, value) {
			const emittedObject = {
				filterId,
				value,
			}
			this.$emit('emitErrorEvent', emittedObject)
		},
		handleIsoShowing(value) {
			this.selectedNationalitiesIso = value
		},
		handleHintForFromDatesMultiple(values) {
			this.selectedFromDates = values
		},
		handleHintForTillDatesMultiple(values) {
			this.selectedTillDates = values
		},
	},
	computed: {
		orderIdsFilled() {
			return this.selectedOrderIds.length > 0
		},
		paymentTransactionIdsFilled() {
			return this.selectedPaymentTransactionIds.length > 0
		},
		couponCodesFilled() {
			return this.selectedCouponCodes.length > 0
		},
		showFilters() {
			return !this.orderIdsFilled && !this.paymentTransactionIdsFilled && !this.couponCodesFilled
		},
		colWidth() {
			return this.orderIdsFilled || this.paymentTransactionIdsFilled || this.couponCodesFilled ? 12 : 6
		},
	},
}
</script>

<style>

</style>
